<template lang="pug">
 .b2b-page-recadvs-emits
    ods-module.box-card
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("recadv.recadv_detail.create_invoice_buttons_tooltip")', placement='bottom')
                  ods-button(
                    v-show='(canCreateInvoiceRecadv && docStatus === "RECEIVED") || (canCreateInvoiceParcialRecadv && docStatus === "PARTIALLY_INVOICED")',
                    type='primary',
                    icon='ods-icon-plus',
                    size='small',
                    circle,
                    @click.native='handleCreateInvoice')
                    | {{ $t('recadv.recadv_detail.create_invoice_buttons') }}
              ods-tooltip(:content='$t("recadv.recadv_detail.download_pdf_buttons_tooltip")', placement='bottom')
                  ods-button(
                    v-if='!cantViewRecadvPdf',
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='downloadPdf')
                    | {{ $t('recadv.recadv_detail.download_pdf_buttons') }}
              ods-tooltip(:content='$t("invoice_detail.buttons.download_original_signed_tooltip")', placement='bottom')
                  ods-button(
                    v-show='canViewRecadvOriginal && recadvDetailForm.path'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadOriginal(recadvDetailForm)')
                    | {{ $t('invoice_detail.buttons.download_original_signed') }}
              ods-tooltip(:content='$t("invoice_detail.buttons.download_metadata_tooltip")', placement='bottom')
                  ods-button(
                    v-show='recadvDetailForm.pathRecadvMetadata && canViewRecadvMetadata'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadMetadata(recadvDetailForm)')
                    | {{ $t('invoice_detail.buttons.download_metadata') }}
              ods-tooltip(:content='$t("recadv.recadv_detail.rejected_recadv_buttons_tooltip")', placement='bottom')
                  ods-button(
                    v-show='canRejectRecadv && docStatus === "RECEIVED" ',
                    icon='ods-icon-disable',
                    size='small',
                    circle,
                    @click.native='isShowDialogRejectedRecadv = true')
                    | {{ $t('recadv.recadv_detail.rejected_recadv_buttons') }}
              ods-tooltip(:content='$t("recadv.recadv_detail.activate_recadv_buttons_tooltip")', placement='bottom')
                  ods-button(
                    v-show='canModifyRecadv && docStatus === "REJECTED" ',
                    icon='ods-icon-checkmark-2',
                    size='small',
                    circle,
                    @click.native='goActivateRecadv()')
                    | {{ $t('recadv.recadv_detail.activate_recadv_buttons') }}

    ods-module.collapse
      ods-accordion(v-model='activateDetail', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('msg_generics.detail') }}

          ods-form(
            ref='recadvDetailForm',
            :model='recadvDetailForm',
            :rules='recadvDetailFormRules',
            label-width='14rem',
            label-position='top',
            size='small',
            status-icon)
            ods-row(type='flex')
              ods-col(:span='24')
                ods-form-item.moreSpace(
                  prop='sellerName',
                  :label='$t("recadv.recadv_entity_table.seller")'
                  style='margin-top: 0px;')
                  ods-input(
                    readonly,
                    v-model='recadvDetailForm.sellerName')
            ods-table(
              :data='recadvDetailForm.sellerCentres'
              style='width: 100%',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='code',
                width='160'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.code.label")')
              ods-table-column(
                prop='description',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.name.label")')
              ods-table-column(
                prop='centreRoleTypeCode',
                width='190'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.role.label")',
                :formatter='formatterRole')
              ods-table-column(
                prop='address',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.address.label")')
            ods-row(type='flex')
              ods-col(:span='24')
                ods-form-item.moreSpace(
                  prop='buyerName',
                  :label='$t("recadv.recadv_entity_table.buyer")')
                  ods-input(
                    readonly,
                    v-model='recadvDetailForm.buyerName')
            ods-table(
              :data='recadvDetailForm.buyerCentres'
              style='width: 100%',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='code',
                width='160'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.code.label")')
              ods-table-column(
                prop='description',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.name.label")')
              ods-table-column(
                prop='centreRoleTypeCode',
                width='190'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.role.label")',
                :formatter='formatterRole')
              ods-table-column(
                prop='address',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.address.label")')
            ods-row(type='flex')
              ods-col(:span='6')
                ods-form-item(
                  prop='recadvNumber',
                  :label='$t("recadv.recadv_entity_table.num_recadv")')
                  ods-input(
                    readonly,
                    v-model='recadvDetailForm.recadvNumber')
              ods-col(:span='6')
                ods-form-item(
                  prop='creationDateTime',
                  :label='$t("recadv.recadv_entity_table.date_creation")')
                  ods-input(
                    readonly,
                    v-model='creationDateTimeFormatted')
              ods-col(:span='6')
                ods-form-item(
                  prop='receivingDateTime',
                  :label='$t("recadv.recadv_entity_table.date_receiving")')
                  ods-input(
                    readonly,
                    v-model='receivingDateTimeFormatted')
              ods-col(:span='6')
                ods-form-item(
                  prop='statusId',
                  :label='$t("recadv.recadv_entity_table.status")')
                  ods-input(
                    readonly,
                    v-model='recadvDetailForm.statusId')
            ods-row(type='flex')
              ods-col(:span='24')

            ods-row(type='flex')
              ods-col(:span='4')
                ods-form-item(
                  v-if='canChangeStatusRecadv',
                  :label='$t("recadv.recadv_detail.change_state.label")',
                  prop='statusCode')
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='recadvDetailForm.statusCode',
                    :disabled='!canChangeStatusRecadv'
                    filterable,
                    clearable,
                    :placeholder='$t("recadv.recadv_detail.change_state.placeholder")'
                    @change='changeStatus')
                    ods-option(
                      v-for='option in optionsFilterStatusRecadv',
                      :key='option.id',
                      :label='$t("recadv_status." + option.code)',
                      :value='option.code')
              ods-col(:span='2')
              ods-col(:span='16')
                ods-form-item(
                  v-if='canChangeStatusRecadv && recadvDetailForm.statusCode'
                  :label='$t("invoice_detail.invoice_detail_edit_form.observations")',
                  prop='observations')
                  ods-input(v-model='recadvDetailForm.observations')

    ods-module.collapse
      ods-accordion(v-model='activateLines', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('recadv.recadv_detail.reception_lines') }}
              ods-row(type='flex', justify='around')
                ods-tooltip(:content='$t("recadv.recadv_detail.create_line_buttons_tooltip")', placement='bottom')
                  div
                    ods-button(
                        v-if='canModifyRecadv && docStatus === "REJECTED" && statusDocumentRecadv != "MODIFIED" && this.recadvDetailForm.rejectSeller',
                        icon='ods-icon-pencil',
                        size='small',
                        circle,
                        @click.native='isShowDialogCheckLine = true')
                        | {{ $t('recadv.recadv_detail.rejected_recadv_lineError') }}
            span.info(v-show='!recadvsEmitLine.length') {{ $t('recadv.recadv_detail.recadv_line_no_data') }}

          //- Tabla lineas recepción
          ods-table(
            v-if='recadvsEmitLine.length > 0 ',
            :data='recadvsEmitLine',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            @selection-change='handleSelectionChange',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              v-if='canCreateInvoiceParcialRecadv',
              type='selection',
              width='55')
            ods-table-column(
              prop='lineNumber',
              width='75'
              :label='$t("recadv.recadv_entity_table_detail.lineNumber")')
            ods-table-column(
              prop='code',
              width='130'
              v-if='isShowCodeLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.code")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='itemCodeSeller',
              width='155'
              v-if='isShowItemCodeSellerRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.itemCodeSeller")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='itemCodeBuyer',
              width='160'
              v-if='isShowItemCodeBuyerRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.itemCodeBuyer")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='description',
              width='260'
              v-if='isShowDescriptionRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.description")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='order',
              width='100'
              v-if='isShowOrderLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.order")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='deliveryNoteNumber',
              width='120'
              v-if='isShowDeliveryNoteNumberRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.deliveryNoteNumber")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='deliveryNoteLine',
              width='120'
              v-if='isShowDeliveryNoteLineRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.deliveryNoteLine")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='despatchQuantity',
              width='150'
              v-if='isShowDespatchQuantityLinesEmit'
              align='right',
              :label='$t("recadv.recadv_entity_table_detail.despatch_quantity")',
              :formatter='formatterQuantity',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='receivedQuantity',
              width='150'
              v-if='isShowReceivedQuantityLinesEmit'
              align='right',
              :label='$t("recadv.recadv_entity_table_detail.received_quantity")',
              :show-overflow-tooltip='true',
              :formatter='formatterQuantity')
            ods-table-column(
              prop='acceptedQuantity',
              width='150'
              v-if='isShowAcceptedQuantityLinesEmit'
              align='right',
              :label='$t("recadv.recadv_entity_table_detail.accepted_quantity")',
              :show-overflow-tooltip='true',
              :formatter='formatterQuantity')
            ods-table-column(
              prop='measure',
              width='130'
              v-if='isShowMeasureRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.measure")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='price',
              width='120'
              v-if='isShowPriceLinesEmit'
              align='right',
              :label='$t("recadv.recadv_entity_table_detail.price")',
              :show-overflow-tooltip='true',
              :formatter='formatterDecimal')
            ods-table-column(
              prop='currency',
              width='80'
              v-if='isShowCurrencyRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.currency")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='status',
              width='100'
              v-if='isShowStatusRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.status")',
              :show-overflow-tooltip='true',
              :formatter='formatterStatus')
            ods-table-column(
              prop='subtype',
              width='100'
              v-if='isShowSubtypeRecadvLinesEmit'
              :label='$t("recadv.recadv_entity_table_detail.subtype")',
              :show-overflow-tooltip='true',
              :formatter='formatterSubtype')
            ods-table-column(
              :label='$t("recadv.recadv_entity_table_detail.options")'
              :show-overflow-tooltip='true')
              template(slot-scope="scope")
                ods-tooltip(:content='$t("recadv.recadv_detail.edit_line_buttons_tooltip")', placement='bottom')
                  ods-button(
                    v-if='canModifyRecadv && scope.row.documentStatus === "ADDED" && scope.row.status === "REJECTED"',
                    style=' padding-left: 0px; padding-right: 0px;'
                    type='neutral',
                    @click='showEditNewLine(scope.row)')
                    ods-icon(name='pencil', size='16')

            ods-table-column(
              :render-header='renderHeaderActions',
              width='120')

    //- Dialogo Datos de configuración
    ods-dialog(
      ref='dialogRejectedRecadv',
      :title='$t("recadv.recadv_detail.dialog_rejected_recadv.title")',
      :visible.sync='isShowDialogRejectedRecadv',
      @close='handleCloseDialog',
      width='30%')

      ods-form(
        ref='formDialogRejectedRecadvForm',
        :model='dialogRejectedRecadvForm',
        :rules='rulesDialogRejectedRecadvForm')

        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_rejected_recadv.value")',
          size='mini',
          style='width: 100%;',
          prop='motive')
        ods-input(
          type='textarea',
          :rows='4',
          :placeholder='$t("recadv.recadv_detail.dialog_rejected_recadv.placeholder")',
          v-model='dialogRejectedRecadvForm.motive')

      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitRejectedRecadv("formDialogRejectedRecadvForm")')
          | {{ $t('buttons.btnOk') }}

    //- Dialogo Datos NUEVA LINEA de descuadre
    ods-dialog(
      ref='formDialogNewLineRecadvForm',
      :title='$t("recadv.recadv_detail.dialog_new_check_line_recadv.title")',
      :visible.sync='isShowDialogCheckLine',
      @close='handleCloseDialogNewLine',
      width='40%')
      ods-form(
        ref='formDialogNewLineRecadvForm',
        :model='dialogNewLineRecadvForm',
        :rules='rulesDialogNewLineRecadvForm',
        size='mini')
        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_new_check_line_recadv.description")',
          size='mini',
          prop='description')
          ods-input(
            type='text',
            :rows='1',
            v-model='dialogNewLineRecadvForm.description')
        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_new_check_line_recadv.quantity")',
          size='mini',
          prop='quantity')
          ods-input(
            type='text',
            :rows='1',
            v-model='dialogNewLineRecadvForm.quantity')
        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_new_check_line_recadv.priceUnit")',
          size='mini',
          prop='priceUnit')
          ods-input(
            type='text',
            :rows='1',
            v-model='dialogNewLineRecadvForm.priceUnit')
        //- Boton desplegable con unidades
        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_new_check_line_recadv.measure")',
          size='mini',
          prop='measure')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogNewLineRecadvForm.measure',
            :placeholder='$t("recadv.recadv_detail.dialog_new_check_line_recadv.search_measure")')
            ods-option(
              v-for='optionMeasure in optionsMeasure',
              :key='optionMeasure.id',
              :label='$t("unit_of_measure." + optionMeasure.code)',
              :value='optionMeasure.id')

      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitNewLineRecadv("formDialogNewLineRecadvForm")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo Datos Linea de EDITAR
    ods-dialog(
      ref='dialogNewLineEditRecadv',
      :title='$t("recadv.recadv_detail.dialog_new_check_line_recadv.title_edit")',
      :visible.sync='isShowDialogCheckLineEdit',
      @close='handleCloseDialogNewLineEdit',
      width='40%')
      ods-form(
        ref='formDialogNewLineEditRecadvForm',
        :model='dialogNewLineEditRecadvForm',
        :rules='rulesDialogNewLineEditRecadvForm',
        size='mini')
        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_new_check_line_recadv.description")',
          size='mini',
          prop='description')
          ods-input(
            type='text',
            :rows='1',
            v-model='dialogNewLineEditRecadvForm.description')
        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_new_check_line_recadv.quantity")',
          size='mini',
          prop='quantity')
          ods-input(
            type='text',
            :rows='1',
            v-model='dialogNewLineEditRecadvForm.quantity')
        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_new_check_line_recadv.priceUnit")',
          size='mini',
          prop='priceUnit')
          ods-input(
            type='text',
            :rows='1',
            v-model='dialogNewLineEditRecadvForm.priceUnit')
        //- Boton desplegable con unidades
        ods-form-item(
          :label='$t("recadv.recadv_detail.dialog_new_check_line_recadv.measure")',
          size='mini',
          prop='measure')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogNewLineEditRecadvForm.measure',
            :placeholder='$t("recadv.recadv_detail.dialog_new_check_line_recadv.search_measure")')
            ods-option(
              v-for='optionMeasure in optionsMeasure',
              :key='optionMeasure.id',
              :label='$t("unit_of_measure." + optionMeasure.code)',
              :value='optionMeasure.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitNewLineEditRecadv("formDialogNewLineEditRecadvForm")')
          | {{ $t('buttons.btnSave') }}

    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            v-if='canChangeStatusRecadv'
            type='primary',
            size='large'
            @click='submitRecadvDetailEditForm')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            v-if='canChangeStatusRecadv'
            ref='buttonCancel',
            size='large'
            type='neutral',
            @click='cancelRecadvDetailEditForm')
            | {{ $t('buttons.btnClear') }}

    ods-module.collapse
      ods-accordion(v-model='activateRelatedDocuments', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('recadv.recadv_detail.related_documents') }}
            span.info(v-show='!relatedDocuments.length') {{ $t('recadv.recadv_detail.related_documents_no_data') }}
          //- Tabla documentos relacionados
          ods-table(
            v-if='relatedDocuments.length > 0 ',
            :data='relatedDocuments',
            style='width: 100%',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='idDestinationDocument',
              :label='$t("recadv.recadv_related_documents_table.destinationDocument")')
              template(slot-scope='scope')
                span(v-if='scope.row.idDestinationDocument')
                a(
                  @click='goToDetail(scope.row.idDestinationDocument, scope.row.destinationDocumentType)',
                  style='color: var(--color-bg-interactive); cursor: pointer;'
                )
                  | {{ scope.row.destinationDocumentNumber }}
            ods-table-column(
              prop='destinationDocumentType',
              :label='$t("recadv.recadv_related_documents_table.destinationDocumentType")')
              template(slot-scope='scope')
                span(v-if="scope.row.destinationDocumentType === 'INVOICE'") {{ $t('document_type.INVOICE') }}
                span(v-else-if="scope.row.destinationDocumentType === 'PURCHASEORDER'") {{ $t('document_type.PURCHASEORDER') }}
                span(v-else-if="scope.row.destinationDocumentType === 'DELIVERYNOTE'") {{ $t('document_type.DELIVERYNOTE') }}
                span(v-else-if="scope.row.destinationDocumentType === 'RECEIVEADVICE'") {{ $t('document_type.RECEIVEADVICE') }}
                span(v-else) {{ scope.row.destinationDocumentType }}
            ods-table-column(
              prop='creationDateTime'
              :label='$t("recadv.recadv_related_documents_table.date")',
              :formatter='dateFormatted')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTableLinesRecadvsEmit from '@/views/recepciones/emitidas/B2bTableLinesRecadvsEmit'
import B2bTimeline from '@/components/B2bTimeline'
import router from '@/router/index'
import Utils from '@/components/shared/Utils'
import moment from 'moment'

export default {
  name: 'b2b-page-recadvs-emits',
  mixins: [Utils],
  data () {
    return {
      activateLines: ['1'],
      activateDetail: ['1'],
      activateRelatedDocuments: ['1'],
      relatedDocuments: [],
      recadvsEmitLine: [],
      statusDocumentRecadv: null,
      docStatus: null,
      measureUnit: '',
      searchType: 'EMITTED',
      dialogNewLineRecadvForm: {
        description: null,
        quantity: '',
        priceUnit: '',
        measure: null
      },
      multipleSelection: [],
      recadvDetailForm: {
        buyerName: null,
        sellerName: null,
        recadvNumber: null,
        receivingDateTime: '',
        creationDateTime: '',
        documentStatus: null,
        projectName: null,
        invoiceNumber: null,
        statusCode: null,
        statusId: null
      },
      currentRow: {},

      isShowDialogCheckLine: false,
      isShowDialogCheckLineEdit: false,
      // Rechazo de recepción
      isShowDialogRejectedRecadv: false,
      dialogRejectedRecadvForm: {
        motive: null
      },
      rulesDialogRejectedRecadvForm: {
        motive: [
          { required: true, message: this.$t('recadv.recadv_detail.dialog_rejected_recadv.motive_required'), trigger: 'change' },
          { max: 256, message: this.$t('validations.maxlenght', { maxlenght: 256 }), trigger: 'change' }
        ]
      },
      optionsMeasure: [],
      searchMeasure: [],
      dialogNewLineEditRecadvForm: {
        description: null,
        quantity: '',
        priceUnit: '',
        measure: null,
        recadvIdLine: null
      }
    }
  },

  components: {
    B2bTimeline,
    B2bTableLinesRecadvsEmit
  },

  computed: {
    ...mapGetters([
      // Permisos
      'optionsFilterStatusRecadv',
      'canRejectRecadv',
      'canModifyRecadv',
      'canCreateInvoiceRecadv',
      'canCreateInvoiceParcialRecadv',
      'createInvoice',
      'getActiveLang',
      'isShowCodeLinesEmit',
      'isShowItemCodeSellerRecadvLinesEmit',
      'isShowItemCodeBuyerRecadvLinesEmit',
      'isShowDescriptionRecadvLinesEmit',
      'isShowOrderLinesEmit',
      'isShowDeliveryNoteNumberRecadvLinesEmit',
      'isShowDeliveryNoteLineRecadvLinesEmit',
      'isShowDespatchQuantityLinesEmit',
      'isShowReceivedQuantityLinesEmit',
      'isShowAcceptedQuantityLinesEmit',
      'isShowMeasureRecadvLinesEmit',
      'isShowPriceLinesEmit',
      'isShowCurrencyRecadvLinesEmit',
      'isShowStatusRecadvLinesEmit',
      'isShowSubtypeRecadvLinesEmit',
      'canChangeStatusRecadv',
      'canViewRecadvOriginal',
      'canViewRecadvMetadata',
      'cantViewRecadvPdf'
    ]),
    rulesDialogNewLineRecadvForm () {
      const checkIntegerNumber = (rule, value, callback) => {
        if (!this.checkCorrectNumber(value, true)) {
          if (this.getCharFailedNumeric(value) === 'NoNumeric') {
            callback(new Error(this.$t('msg_generics.format_invalid')))
          } else {
            callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
          }
        } else if (this.countDecimals(value) > 6) {
          callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
        }
        callback()
      }
      const checkNumber = (rule, value, callback) => {
        if (!this.checkCorrectNumber(value, false)) {
          if (this.getCharFailedNumeric(value) === 'NoNumeric') {
            callback(new Error(this.$t('msg_generics.format_invalid')))
          } else {
            callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
          }
        } else if (this.countDecimals(value) > 6) {
          callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
        } else if (this.isOrder && value == null) {
          callback(new Error(this.$t('msg_generics.field_required')))
        }
        callback()
      }
      return {
        description: [
          { required: true, message: this.$t('recadv.recadv_detail.dialog_new_check_line_recadv.date_required'), trigger: 'change' },
          { max: 80, message: this.$t('validations.maxlenght', { maxlenght: 80 }), trigger: 'change' }
        ],
        quantity: [
          { required: true, message: this.$t('recadv.recadv_detail.dialog_new_check_line_recadv.date_required'), trigger: 'change' },
          { validator: checkIntegerNumber, trigger: 'change' }
        ],
        priceUnit: [
          { required: true, message: this.$t('recadv.recadv_detail.dialog_new_check_line_recadv.date_required'), trigger: 'change' },
          { validator: checkNumber, trigger: 'change' }
        ],
        measure: [
          { required: true, message: this.$t('recadv.recadv_detail.dialog_new_check_line_recadv.date_required'), trigger: 'change' }
        ]
      }
    },
    rulesDialogNewLineEditRecadvForm () {
      const checkIntegerNumber = (rule, value, callback) => {
        if (!this.checkCorrectNumber(value, true)) {
          if (this.getCharFailedNumeric(value) === 'NoNumeric') {
            callback(new Error(this.$t('msg_generics.format_invalid')))
          } else {
            callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
          }
        } else if (this.countDecimals(value) > 6) {
          callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
        }
        callback()
      }
      const checkNumber = (rule, value, callback) => {
        if (!this.checkCorrectNumber(value, false)) {
          if (this.getCharFailedNumeric(value) === 'NoNumeric') {
            callback(new Error(this.$t('msg_generics.format_invalid')))
          } else {
            callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
          }
        } else if (this.countDecimals(value) > 6) {
          callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
        } else if (this.isOrder && value == null) {
          callback(new Error(this.$t('msg_generics.field_required')))
        }
        callback()
      }
      return {
        description: [{
          required: true,
          message: this.$t('recadv.recadv_detail.dialog_new_check_line_recadv.date_required'),
          trigger: 'change'
        },
        {
          max: 80,
          message: this.$t('validations.maxlenght', { maxlenght: 80 }),
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          message: this.$t('recadv.recadv_detail.dialog_new_check_line_recadv.date_required'),
          trigger: 'change'
        },
        { validator: checkIntegerNumber, trigger: 'change' }],
        priceUnit: [{
          required: true,
          message: this.$t('recadv.recadv_detail.dialog_new_check_line_recadv.date_required'),
          trigger: 'change'
        },
        { validator: checkNumber, trigger: 'change' }]
      }
    },
    creationDateTimeFormatted () { // eslint-disable-line
      if (this.recadvDetailForm.creationDateTime) {
        const date = moment(this.recadvDetailForm.creationDateTime)
        return date.format(this.$t('date_format_long'))
      }
    },
    receivingDateTimeFormatted () { // eslint-disable-line
      if (this.recadvDetailForm.receivingDateTime) {
        const date = moment(this.recadvDetailForm.receivingDateTime)
        return date.format(this.$t('date_format_long'))
      }
    },
    recadvDetailFormRules () {
      const checkObservations = (rule, value, callback) => {
        const self = this
        const estado = this.optionsFilterStatusRecadv.find(function (t) {
          return t.code === self.recadvDetailForm.statusCode
        })
        const observations = this.recadvDetailForm.observations
        if (estado && estado.code === 'REJECTED' && !observations) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }
      return {
        observations: [
          { max: 256, message: this.$t('msg_generics.max_num_character', { max: 256 }), trigger: 'blur' },
          { validator: checkObservations, trigger: 'blur, change' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'modifyRecadv',
      'getRecadvLines',
      'getRelatedDocumentsRecadv',
      'getRecadvDetail',
      'rejectedRecadv',
      'activateRecadv',
      'downloadRecadvPdfMultiple',
      'createInvoiceState',
      'getOptionsUnitsOfMeasure',
      'newLineRecadv',
      'downloadRecadvOriginal',
      'downloadRecadvMetadata'
    ]),

    changeStatus (data) {
      this.optionsFilterStatusRecadv.find(function (t) {
        return t.id === data
      })
      this.$refs.recadvDetailForm.clearValidate()
    },

    showEditNewLine (data) {
      this.dialogNewLineEditRecadvForm.description = data.description
      this.dialogNewLineEditRecadvForm.quantity = data.acceptedQuantity
      this.dialogNewLineEditRecadvForm.priceUnit = data.price.toLocaleString(this.getActiveLang, { useGrouping: false })
      this.dialogNewLineEditRecadvForm.measure = data.measure
      this.dialogNewLineEditRecadvForm.recadvIdLine = data.id
      this.isShowDialogCheckLineEdit = true
    },
    formatterStatus (row, column) {
      return row.status != null ? this.$t('recadv_status.' + row.status) : null
    },
    formatterSubtype (row, column) {
      return row.subtype != null ? this.$t('recadv_subtype.' + row.subtype) : null
    },
    formatterDecimal (row, column) {
      if (row[column.property]) {
        return this.$n(row[column.property], 'two_to_six_decimal')
      }
      return ''
    },
    formatterQuantity (row, column) {
      if (row[column.property]) {
        return this.$n(row[column.property], 'three_decimal')
      }
      return ''
    },
    formatterRole (row, column) {
      if (row[column.property]) {
        return this.$t('centre_role_type_order.' + row[column.property])
      }
      return ''
    },

    //  Reseteo al cerrar dialogo
    handleCloseDialog () {
      this.$refs.formDialogRejectedRecadvForm.resetFields()
    },

    handleCloseDialogNewLine () {
      this.$refs.formDialogNewLineRecadvForm.resetFields()
    },

    handleCloseDialogNewLineEdit () {
      this.$refs.formDialogNewLineEditRecadvForm.resetFields()
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },

    dateFormatted (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    renderHeaderActions: h => {
      return <B2bTableLinesRecadvsEmit />
    },

    async handleDownloadOriginal (recadv) {
      console.log('handleDownloadOriginal: ', recadv.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const params = {
          recadvsId: recadv.id,
          searchType: this.searchType
        }
        const filename = await this.downloadRecadvOriginal(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleDownloadMetadata (recadv) {
      console.log('handleDownloadMetadata: ', recadv.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })
      try {
        const params = {
          recadvsId: recadv.id,
          searchType: this.searchType
        }
        const filename = await this.downloadRecadvMetadata(params)
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Creación de una factura
    async handleCreateInvoice () {
      if (this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
        let createInvoice = true
        console.log('multipleSelection', this.multipleSelection)
        // comprobamos que las lineas no estén rechazadas ni facturadas
        if (this.multipleSelection.length > 0) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            if (this.multipleSelection[0].status === 'REJECTED' || this.multipleSelection[0].status === 'FULLY_INVOICED') {
              createInvoice = false
            }
          }
        }
        if (!createInvoice) {
          await this.$notify({
            title: this.$t('order.order_detail.notify.line_error'),
            type: 'error',
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: 10000
          })
        } else {
          const invoice = {
            idRecadv: this.$route.params.recadvId,
            lineListIds: this.multipleSelection.map(item => item.id)
          }
          await this.createInvoiceState(invoice)
          router.push({ name: 'creacion-factura-recepciones-emitidas', query: { type: 'RECADV_EMIT' } })
        }
      }
    },

    // Descarga de pdf
    async downloadPdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })

      try {
        if (this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
          const params = {
            recadvsIds: [this.$route.params.recadvId],
            searchType: this.searchType
          }
          const filename = await this.downloadRecadvPdfMultiple(params)
          this.$notify({
            title: this.$t('recadv.recadv_detail.notify.download_pdf', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // opciones de deplegable unidad de medida
    async getOptionsUnitsOfMeasureOptions () {
      // Get opciones de medida
      try {
        this.optionsMeasure = await this.getOptionsUnitsOfMeasure()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Lineas de una recepción
    async getRecadvsLinesEmitOnDatabase () {
      // Get datos lineas  de la recepción
      try {
        if (this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
          const dataQuery = {
            query: {
              searchType: this.searchType,
              recadvId: this.$route.params.recadvId
            }
          }
          const response = await this.getRecadvLines(dataQuery)
          console.log('response: ', response)
          this.recadvsEmitLine = response.data
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Documentos relacionados
    async getRelatedDocumentsOnDatabase () {
      // Get documentos relacionados de la recepción
      try {
        const dataQuery = {
          query: {
            searchType: this.searchType,
            recadvId: this.$route.params.recadvId
          }
        }
        const response = await this.getRelatedDocumentsRecadv(dataQuery)
        this.relatedDocuments = response.data
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Enlace al detalle del documento y tipo de documento
    async goToDetail (documentId, documentType) {
      console.log('Go to detail: ', documentId)
      console.log('Go to document type: ', documentType)
      if (documentType === 'DELIVERYNOTE') {
        router.push({
          name: 'delivery-note-received-detail',
          params: {
            deliveryId: documentId
          }
        })
      } else if (documentType === 'INVOICE') {
        router.push({
          name: 'factura-recibida-detail',
          params: {
            invoiceNoteId: documentId
          }
        })
      } else if (documentType === 'PURCHASEORDER') {
        router.push({
          name: 'order-emit-detail',
          params: {
            orderId: documentId
          }
        })
      } else if (documentType === 'RECEIVEADVICE') {
        router.push({
          name: 'recadv-emit-detail',
          params: {
            recadvId: documentId
          }
        })
      }
    },

    // Linea de descuadre NEW LINE
    onSubmitNewLineRecadv (formNewLine) {
      this.$refs[formNewLine].validate(async (valid) => {
        if (valid && this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
          try {
            console.log('onSubmitNewLineRecadv VALID: ', this.dialogNewLineRecadvForm)
            const request = {
              recadvId: this.$route.params.recadvId,
              description: this.dialogNewLineRecadvForm.description,
              quantity: this.dialogNewLineRecadvForm.quantity,
              priceUnit: this.dialogNewLineRecadvForm.priceUnit,
              measure: this.dialogNewLineRecadvForm.measure,
              idRecadvLine: null,
              searchType: this.searchType
            }
            await this.newLineRecadv(request)
            // Refrescamos
            await this.getRecadvsEmitOnDatabase()
            await this.getRecadvsLinesEmitOnDatabase()
            // Get Documentos relacionados
            await this.getRelatedDocumentsOnDatabase()
            this.isShowDialogCheckLine = false

            this.$notify({
              title: this.$t('recadv.recadv_detail.notify.recadv_new_line'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            this.$refs[formNewLine].resetFields()
            this.isShowDialogCheckLine = false
          }
        } else {
          console.log('onSubmitNewLineRecadv INVALID: ', this.dialogRejectedRecadvForm)
          return false
        }
      })
    },

    submitRecadvDetailEditForm () {
      const recadvId = this.$route.params.recadvId
      this.$refs.recadvDetailForm.validate(async (valid) => {
        if (valid && recadvId != '_blank') {// eslint-disable-line
          const load = this.$loading({
            lock: true,
            text: this.$t('recadv.recadv_detail.change_state.load')
          })
          console.log('submitRecadvDetailEditForm: ', this.recadvDetailForm)
          try {
            const dataQuery = {
              query: {
                statusCode: this.recadvDetailForm.statusCode,
                observations: this.recadvDetailForm.observations,
                searchType: this.searchType
              }
            }
            const params = {
              recadvId: recadvId,
              dataQuery: dataQuery
            }
            await this.modifyRecadv(params)
            this.$refs.recadvDetailForm.clearValidate()
            this.recadvDetailForm.statusId = this.$t('recadv_status.' + this.recadvDetailForm.statusCode)
            const length = this.recadvsEmitLine.length
            if (length > 0) {
              for (let i = 0; i < length; i++) {
                this.recadvsEmitLine[i].status = this.recadvDetailForm.statusCode
              }
            }
            this.recadvDetailForm.statusCode = null
            this.recadvDetailForm.observations = null

            this.$notify({
              title: this.$t('recadv.recadv_detail.notify.submit_edit_recadv_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('submitRecadvDetailEditForm CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs.recadvDetailForm.resetFields()
          } finally {
            load.close()
          }
        } else {
          console.log('submitRecadvDetailEditForm: ', this.recadvDetailForm)
          return false
        }
      })
    },

    async cancelRecadvDetailEditForm () {
      this.$refs.buttonCancel.$el.blur()
      this.recadvDetailForm.statusCode = null
      this.recadvDetailForm.observations = null
    },

    // Linea de descuadre EDIT
    onSubmitNewLineEditRecadv (formEditLine) {
      this.$refs[formEditLine].validate(async (valid) => {
        if (valid && this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
          try {
            console.log('onSubmitNewLineEditRecadv VALID: ', this.dialogNewLineEditRecadvForm)
            const response = await this.getOptionsUnitsOfMeasure()
            this.searchMeasure = response.data
            const request = {
              recadvId: this.$route.params.recadvId,
              description: this.dialogNewLineEditRecadvForm.description,
              quantity: this.dialogNewLineEditRecadvForm.quantity,
              priceUnit: this.dialogNewLineEditRecadvForm.priceUnit,
              measure: this.dialogNewLineEditRecadvForm.measure,
              idRecadvLine: this.dialogNewLineEditRecadvForm.recadvIdLine,
              searchType: this.searchType
            }
            await this.newLineRecadv(request)
            // Refrescamos
            await this.getRecadvsEmitOnDatabase()
            await this.getRecadvsLinesEmitOnDatabase()
            // Get Documentos relacionados
            await this.getRelatedDocumentsOnDatabase()
            this.isShowDialogCheckLineEdit = false

            this.$notify({
              title: this.$t('recadv.recadv_detail.notify.recadv_edit_line'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            this.$refs[formEditLine].resetFields()
            this.isShowDialogCheckLineEdit = false
          }
        } else {
          console.log('onSubmitNewLineEditRecadv INVALID: ', this.dialogRejectedRecadvForm)
          return false
        }
      })
    },

    // Detalle Recepcion
    async getRecadvsEmitOnDatabase () {
      try {
        if (this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
          this.recadvDetailForm = await this.getRecadvDetail({
            recadvID: this.$route.params.recadvId,
            searchType: this.searchType
          })
          // Guardamos estado
          this.docStatus = this.recadvDetailForm.statusId
          this.statusDocumentRecadv = this.recadvDetailForm.documentStatus
          // Formateamos estado
          if (this.docStatus != null && this.docStatus === 'REJECTED' && this.recadvDetailForm.rejectSeller) {
            const REJECTED_SELLER = 'REJECTED_SELLER'
            this.recadvDetailForm.statusId = this.$t('recadv_status.' + REJECTED_SELLER)
          } else {
            this.recadvDetailForm.statusId = this.$t('recadv_status.' + this.recadvDetailForm.statusId)
            console.log(this.recadvDetailForm)
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    /** Activación recepcion */
    async goActivateRecadv () {
      try {
        if (this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
          this.$confirm(this.$t('recadv.recadv_detail.confirm.title_recadv_activate', { recadvID: this.recadvDetailForm.recadvNumber, sellerName: this.recadvDetailForm.sellerName }), {
            confirmButtonText: this.$t('recadv.recadv_detail.confirm.confirm_button_recadv_activate'),
            showCancelButton: false,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            const request = {
              recadvId: this.$route.params.recadvId,
              searchType: this.searchType
            }
            await this.activateRecadv(request)
            // Refrescamos
            await this.getRecadvsEmitOnDatabase()
            await this.getRecadvsLinesEmitOnDatabase()
            // Get Documentos relacionados
            await this.getRelatedDocumentsOnDatabase()
            this.$notify({
              title: this.$t('recadv.recadv_detail.notify.recadv_activate'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }).catch(() => {})
        }
      } catch (error) {
        console.log('removeUserMedia CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    //* * Rechazo de recepcion */
    onSubmitRejectedRecadv (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid && this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
          const load = this.$loading({
            lock: true,
            text: this.$t('recadv.recadv_detail.load.recadv_rejected')
          })
          try {
            console.log('onSubmitRejectedRecadv VALID: ', this.dialogRejectedRecadvForm)
            const request = {
              recadvId: this.$route.params.recadvId,
              motive: this.dialogRejectedRecadvForm.motive,
              searchType: this.searchType
            }
            await this.rejectedRecadv(request)
            // Refrescamos
            await this.getRecadvsEmitOnDatabase()
            await this.getRecadvsLinesEmitOnDatabase()
            // Get Documentos relacionados
            await this.getRelatedDocumentsOnDatabase()

            this.$notify({
              title: this.$t('recadv.recadv_detail.notify.recadv_rejected'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            this.$refs[formName].resetFields()
            this.isShowDialogRejectedRecadv = false
            load.close()
          }
        } else {
          console.log('onSubmitRejectedRecadv INVALID: ', this.dialogRejectedRecadvForm)
          return false
        }
      })
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      // Si se está creando no tenemos aun el id
      if (this.$route.params.recadvId && this.$route.params.recadvId !== 'creacion' && this.$route.params.recadvId !== '_blank') {
      // Detalle recepcion
        await this.getRecadvsEmitOnDatabase()
        // Get Lineas recepción
        await this.getRecadvsLinesEmitOnDatabase()
        // Get Documentos relacionados
        await this.getRelatedDocumentsOnDatabase()
      }
      // Get measures
      await this.getOptionsUnitsOfMeasureOptions()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-recadvs-emits {
  ::v-deep .ods-input__inner {
    background-color: transparent !important;
  }
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 0px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }
  .moreSpace {
    margin-bottom: 0px;
  }
  .ods-form-item {
    margin-bottom: 0px;
    margin-top: 1rem;
  }
  ::v-deep .ods-form-item__label {
    font-weight: 500;
  }
  .ods-button:not(.is-circle) i, .ods-button:not(.is-circle) [class*="ods-icon-"], .ods-button:not(.is-circle) [class*=" ods-icon-"] {
      margin-top: -2px;
      margin-left: 0px;
  }
  .collapse{
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table{
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
      ::v-deep .ods-button{
      background-color: #FFF;
      border-color: #FFF;
      color: #000;
      }
      ::v-deep .ods-input-number .ods-input__inner {
        padding: 4px 30px 4px 8px;
        text-align: right;
      }
    }
    ::v-deep .ods-input.is-disabled .ods-input__inner{
      background-color: transparent;
      border-color: transparent;
      color: black;
      cursor: not-allowed;
      text-align: right;
    }
    ::v-deep .ods-scrollbar__bar.is-horizontal, .ods-scrollbar__bar.is-horizontal {
      opacity: 1;
    }
    ::v-deep .ods-scrollbar__wrap.ods-table__body-wrapper {
      margin-bottom: 20px;
    }
    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
    ::v-deep .ods-date-editor.ods-input {
        width: 120px;
        margin-right: 24px;
      }
  }
  ::v-deep.ods-table__body-wrapper {
    margin-bottom: 20px !important;
  }
}
</style>
